class MobileNavigationMenu extends HTMLElement {
  constructor() {
    super();
    this.submenuOpeners = this.querySelectorAll('.mobile-nav-menu__submenu-opener');
    this.backButtons = document.querySelectorAll('.mobile-submenu__container .back-button');
    this.openingMenu = false;
  }

  connectedCallback() {
    this.submenuOpeners.forEach(opener => {
      opener.addEventListener('click', this.openMenu.bind(this));
    });

    this.backButtons.forEach(button => {
      button.addEventListener('click', this.closeMenu.bind(this));
    });
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => {
        document.querySelectorAll('.mobile-submenu__container').forEach(submenu => {
          submenu.classList.remove('hidden');
        });
      },1000);
    });
  }

  disconnectedCallback() {
    this.submenuOpeners.forEach(opener => {
      opener.removeEventListener('click', this.openMenu);
    });

    this.backButtons.forEach(button => {
      button.removeEventListener('click', this.closeMenu);
    });
  }

  openMenu(event) {
    event.preventDefault();
    if(!this.openingMenu) {
      this.openingMenu = true;
      const target = event.currentTarget;
      const targetedMenuSelector = target.dataset.target;
      document.querySelector(`#${targetedMenuSelector}`).classList.remove('hidden');
      document.querySelector(`#${targetedMenuSelector}`).classList.add('opened');
      let component = this;
      setTimeout(() => {
        component.openingMenu = false;
      },500);
    }
  }

  closeMenu() {
    document.querySelector('.mobile-submenu__container.opened').classList.remove('opened');
  }
}

if (!window.customElements.get("mobile-navigation-menu")) {
  window.customElements.define("mobile-navigation-menu", MobileNavigationMenu);
}